import {createGAEvent, HTO, pushDataLayer} from '@optimaxdev/analytics/mobile';

import {call, select, takeLatest} from 'redux-saga/effects';
import {analytics} from 'libs/analytics/analytics';
import {isHomeTryOnCart, isSelectedCartHTO} from 'selectors/homeTryOn/homeTryOn';
import {FULFILLED} from 'redux-promise-middleware';
import {savePayment} from 'reducers/checkout/paymentMethodActive/paymentMethodActive';
import {getActivePaymentMethod, getCheckoutData} from 'selectors/checkout/checkout';
import {CARD_TYPE} from 'constants/checkout/checkout';
import {isHtoEnabled} from 'constants/flags/flags';

/**
 * Send HTO non-interaction analytics for checkout
 */
export function* sendCheckoutAnalytics() {
    const isExperimentEnabled = yield call(isHtoEnabled);
    if (!isExperimentEnabled) return;

    const isHTOEnabled = yield select(isHomeTryOnCart);
    const eligibleEvent = yield call(
        createGAEvent,
        HTO.CHECKOUT_STATUS,
        {
            hasHTO: isHTOEnabled ? '' : 'Non',
        },
        false,
    );

    yield call<(...args: any[]) => any>(pushDataLayer, eligibleEvent, true);
}

/**
 * Send checkout warning event
 */
export function* sendCheckoutWarningEvent() {
    const {level, type} = yield select(getActivePaymentMethod);
    const isSelected = yield select(isSelectedCartHTO);
    if ((level !== CARD_TYPE.PREPAID && type !== CARD_TYPE.DEBIT) || !isSelected) return;
    const warningEvent = yield call(
        createGAEvent,
        HTO.CHECKOUT_WARNING,
        {
            cardLevel: level === CARD_TYPE.PREPAID ? 'pre-paid' : 'debit',
        },
        false,
    );
    const {
        totals: {total: value},
    } = yield select(getCheckoutData);
    yield call(analytics, {...warningEvent, value}, true);
}

/**
 * Home Try-On checkout saga
 */
export function* htoCheckoutSaga() {
    yield takeLatest(`${savePayment}_${FULFILLED}`, sendCheckoutWarningEvent);
}
